module.exports = __webpack_public_path__ + "static/media/amazon-ad.0585abdf.png";